import { LifestyleOption } from "@/clients/models/LifestyleOption";
import IconCardSelector from "@/components/form/icon-card-selector";
import { IonSkeletonText } from "@ionic/react";

interface LifestyleSelectionListProps {
  isLoading: boolean;
  options: LifestyleOption[];
  selectedPreference: string[];
  handlePreferenceSelect: (preference: LifestyleOption) => () => void;
}

export default function LifestyleSelectionList({
  isLoading,
  options,
  selectedPreference,
  handlePreferenceSelect,
}: LifestyleSelectionListProps) {
  if (isLoading) {
    return (
      <div className="w-full flex flex-col gap-4">
        <IonSkeletonText animated className="h-20 rounded-xl" />
        <IonSkeletonText animated className="h-20 rounded-xl" />
        <IonSkeletonText animated className="h-20 rounded-xl" />
        <IonSkeletonText animated className="h-20 rounded-xl" />
      </div>
    );
  }
  return (
    <div className="pb-20 h-full w-full overflow-y-auto no-scrollbar flex flex-col gap-4">
      {options.map((preference) => (
        <IconCardSelector
          key={preference.title}
          icon={preference.icon}
          title={preference.title}
          description={preference.description}
          selected={selectedPreference?.some((p) => p === preference.value)}
          onClick={handlePreferenceSelect(preference)}
        />
      ))}
    </div>
  );
}
